import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import LocizeTranslationBackend from 'i18next-locize-backend'

import AppCore from 'AppCore'
import SupportedLanguages from 'components/Localization/SupportedLanguages.json'
import { EmbeddedRh24 } from 'features/EmbeddedRh24/EmbeddedRh24'
import { SegmentService, TelemetryService } from './services/Telemetry'
import Layout from './components/Layout'

import moment from 'moment'
import 'moment/locale/nl'
import 'moment/locale/pt-br'

TelemetryService.getInstance().initialize()
SegmentService.getInstance()

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(LocizeTranslationBackend)
  .init({
    debug:
      process.env.NODE_ENV === 'development' &&
      Boolean(process.env.REACT_APP_LOCIZE_PROJECT_ID),
    saveMissing:
      process.env.NODE_ENV === 'development' &&
      Boolean(process.env.REACT_APP_LOCIZE_PROJECT_ID),
    preload: ['en'],
    fallbackLng: 'en',
    ns: ['common', 'project', 'errors'],
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format, lng) => {
        switch (format) {
          case 'intlDate': {
            return new Date(value).toLocaleDateString(lng)
          }
          case 'intlNumber': {
            return parseFloat(value).toLocaleString(lng)
          }
          default:
            return value
        }
      },
    },
    nonExplicitSupportedLngs: true,
    supportedLngs: SupportedLanguages.supported_languages,
    backend: {
      projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
      apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
      referenceLng: 'en',
      allowedAddOrUpdateHosts: ['local.rhodium24.io'],
    },
  })
  .then(() => moment.locale(i18n.language))

i18n.on('languageChanged', (lng) => {
  moment.locale(lng)
})

const App = () => (
  <>
    <EmbeddedRh24 />
    <Layout>
      <AppCore />
    </Layout>
  </>
)

export default App
